import {appInstance} from '@/utils/app-accessor'
import {authStore} from '@/composables/store-accessor'

export default defineNuxtRouteMiddleware(to => {
    const $conf = useNuxtApp().$conf
    const companyType = authStore.companyType
    const personRole = authStore.personRole

    if (
        (to.name === 'scheduler' && !$conf.public.driverScheduler) ||
        (to.name === 'feedback' && !$conf.public.account.reviewsAndFeedback) ||
        (to.name === 'dashboards' &&
            !['director', 'supervisor', 'support'].includes(personRole) &&
            companyType !== 'TOUR_OPERATOR_1LEVEL' &&
            companyType !== 'TOUR_OPERATOR' &&
            companyType !== 'TOUR_AGENCY' &&
            companyType !== 'CORPORATOR') ||
        (to.name === 'payments' &&
            (companyType !== 'TOUR_OPERATOR_1LEVEL' || !$conf.public.account.paymentScheduler)) ||
        (to.name === 'invoices' && (companyType !== 'TOUR_OPERATOR_1LEVEL' || $conf.public.account.paymentScheduler))
    ) {
        throw createError({statusCode: 403, message: appInstance.$i18n.t('error_message.forbidden')})
    }
})
